<rk-programs-header (changeSearch)="onChangeSearch($event)"></rk-programs-header>
<ng-container *ngIf="!(isLoading$ | async); else loading">
  <div class="main" *ngIf="(programsObservable$ | async).length; else noPrograms">
    <ng-container *ngIf="(sortedPrograms$ | async).length; else searchEmpty">
      <div
        class="list-header hidden md:flex"
        rkSort
        [(predicate)]="predicate"
        [(ascending)]="reverse"
        [callback]="transition.bind(this)"
      >
        <div rkSortBy="name" class="name">
          <span translate>SCHEDULE.PROGRAMS.NAME</span> <span class="fa"></span>
        </div>
        <div rkSortBy="playlistsNumber" class="playlist">
          <span translate>MEDIA.COLUMNS.PLAYLISTS</span> <span class="fa"></span>
        </div>
        <div rkSortBy="estimatedDuration" class="estimation">
          <span translate>SCHEDULE.PROGRAMS.ESTIMATED_TIME</span> <span class="fa"></span>
        </div>
      </div>
      <div
        class="list"
        rkPerfectScrollbar
        [fusePerfectScrollbarOptions]="{
          suppressScrollX: true
        }"
        (scroll)="onCloseContextMenu(true)"
      >
        <ng-container *ngIf="radioId$ | async as radioId">
          <rk-program-line
            *ngFor="let program of sortedPrograms$ | async"
            class="block mb-4.5 md:mb-2.5"
            [program]="program"
            [contextMenu]="ctxMenu"
            [contextMenuSubject]="program"
            [isContextMenuOpen]="program.id === $programOpen()?.id"
            (click)="programDetailsPage(radioId, program, $event)"
            (touchstart)="touchEvent(program)"
            (touchmove)="touchEvent(null)"
            (touchend)="programDetailsPage(radioId, program, $event)"
            [resetScrollAxis]="resetChildScrollAxis"
            (resetAllScrollAxis)="onResetAllScrollAxis()"
          ></rk-program-line>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
<context-menu
  #ctxMenu
  (open)="onOpenContextMenu($event.item)"
  (close)="onCloseContextMenu()"
  [menuClass]="'ctx-program'"
  [disabled]="window.innerWidth < 768"
>
  <ng-template contextMenuItem (execute)="editProgram($event.item)">
    <mat-icon fontSet="fa" fontIcon="fa-pen"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.EDIT</span>
  </ng-template>
  <ng-template contextMenuItem (execute)="duplicateProgram($event.item)">
    <mat-icon fontSet="fa" fontIcon="fa-clone"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.DUPLICATE</span>
  </ng-template>
  <ng-template contextMenuItem [divider]="true"></ng-template>
  <ng-template contextMenuItem (execute)="deleteProgram($event.item)">
    <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.DELETE</span>
  </ng-template>
</context-menu>

<ng-template #loading>
  <div class="mt-32">
    <rk-loader [isLoading]="true" [size]="60" [center]="true"></rk-loader>
  </div>
</ng-template>

<ng-template #noPrograms>
  <div class="no-program">
    <img src="/assets/box-empty.svg" />
    <div class="mx-4 mb-3.5 font-semibold text-center" translate>
      SCHEDULE.PROGRAMS.NO_PROGRAM
    </div>
    <rk-button
      class="md:block hidden"
      [label]="'SCHEDULE.PROGRAMS.NEW_PROGRAM' | translate"
      [faIcon]="'fa-plus'"
      (click)="createProgram()"
    ></rk-button>
  </div>
</ng-template>

<ng-template #searchEmpty>
  <div class="no-program">
    <img src="/assets/search-empty.svg" alt="" />
    <div>
      {{ 'MEDIA.TABLE.SEARCH_EMPTY' | translate: { search: searchSubject.value } }}
    </div>
  </div>
</ng-template>

<rk-mobile-fab-button
  *ngIf="!searchSubject.value"
  (click)="createProgram()"
></rk-mobile-fab-button>
